"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollPosition = void 0;
var react_1 = require("react");
var isBrowser = typeof window !== "undefined";
var getScrollPosition = function (element, scrollRegion) {
    var emptyResult = { x: 0, y: 0, visible: false };
    if (!isBrowser)
        return emptyResult;
    var target = element && element.current;
    var parent = scrollRegion && scrollRegion.current;
    if (!target || !parent)
        return emptyResult;
    var targetPos = target.getBoundingClientRect();
    var parentPos = parent.getBoundingClientRect();
    return {
        x: targetPos.left - parentPos.left,
        y: targetPos.top - parentPos.top,
        visible: targetPos.bottom - parentPos.top > 0 &&
            targetPos.right - parentPos.left > 0,
    };
};
function useScrollPosition(effect, deps) {
    var scrollRegionRef = (0, react_1.useRef)(null);
    var watchElementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var listenTo = scrollRegionRef.current;
        if (!listenTo)
            return;
        var handleScroll = function () {
            effect(getScrollPosition(watchElementRef, scrollRegionRef));
        };
        listenTo.addEventListener('scroll', handleScroll);
        return function () { return listenTo.removeEventListener('scroll', handleScroll); };
    }, __spreadArray([scrollRegionRef, watchElementRef], deps, true));
    return { scrollRegionRef: scrollRegionRef, watchElementRef: watchElementRef };
}
exports.useScrollPosition = useScrollPosition;
//# sourceMappingURL=scroll.js.map